import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";

// ignore this page
// only exists because google & bing started lowering our SEO after finding 404s
function PlanDetailPage(props) {
    const router = useRouter();

    // redirect to slug path
    useEffect(() => {
        const slug = router.query.plan_slug;
        const prevQuery = router.query;
        prevQuery.plan_pk && delete prevQuery.plan_pk;

        router.replace({
            pathname: `/plans/plan/${slug}`,
            query: { ...prevQuery },
        });
    }, [router]);

    return (
        <>
            <NextSeo nofollow={true} />
            <h1>
                Inuua house plans: Kenya home designs,Architectural
                design,Architectural plan,House plan,Floor plan,Custom house
                plans,Build a house
                yourself,Bungalow,Maisonette,Mansion,Bedsitter,two bedroom house
                plan,three bedroom house plan,four bedroom house plan,Quantity
                surveyor,Hire a supervisor,Hire a contractor,County building
                approval,Cost of building a house in Kenya,Home Financing
            </h1>
        </>
    );
}

export default PlanDetailPage;
